import { useState } from 'react'
import { DateRangePicker } from 'react-date-range'
import { Portal } from '@nazka/nazka.mapframe.components'

import IconBtnHor from '@App/components/IconBtnHor/IconBtnHor'

import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import './TimeSelector.styl'

function TimeSelector({ selectionRange, setSelectionRange }) {
  const [open, setOpen] = useState(false)

  const handleSelect = (ranges) => {
    setSelectionRange({
      ...ranges.selection,
      startDate: ranges.selection.startDate.toISOString(),
      endDate: ranges.selection.endDate.toISOString(),
    })
  }

  const getDateRangeLabel = () => {
    const msPerDay = 1000 * 60 * 60 * 24

    const normalize = date => new Date(date.getFullYear(), date.getMonth(), date.getDate())
    const tomorrow = new Date(new Date().setUTCHours(0, 0, 0, 0) + 86400000)
    const last7days = new Date(tomorrow - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0] + 'T00:00:00.000Z'
    const start = normalize(new Date(selectionRange?.startDate || last7days))
    const end = normalize(new Date(selectionRange.endDate))
    const today = normalize(new Date())

    // If start and end are the same day
    if (start.getTime() === end.getTime()) {
      if (start.getTime() === today.getTime()) return 'Today'
      return start.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
    }

    // Special cases for "Last" and "Next"
    if (start.getTime() === today.getTime()) {
      const diff = Math.round((end - start) / msPerDay)
      return `Next ${diff + 1} days`
    }

    if (end.getTime() === today.getTime()) {
      const diff = Math.round((end - start) / msPerDay)
      return `Last ${diff + 1} days`
    }

    // Fallback: full date range
    const options = { month: 'short', day: 'numeric' }
    const startStr = start.toLocaleDateString(undefined, options)
    const endStr = end.toLocaleDateString(undefined, options)
    return `${startStr} till ${endStr}`
  }

  return (
    <div className="time-selector">
      <IconBtnHor
        iconProps={{ icon: `/img/icons/calendar.svg`, size: '20px' }}
        onClick={() => {
          setOpen(true)
        }}
      >
        <span>{getDateRangeLabel()}</span>
      </IconBtnHor>
      {open && (
        <Portal>
          <div className="time-selector__backdrop" onClick={() => setOpen(false)}>
            <div className="time-selector__backdrop__content" onClick={e => e.stopPropagation()}>
              <DateRangePicker
                ranges={[{
                  ...selectionRange,
                  startDate: new Date(selectionRange.startDate),
                  endDate: new Date(selectionRange.endDate),
                }]}
                onChange={handleSelect}
              />
              <button className="time-selector__close" onClick={() => setOpen(false)}>
                ✕
              </button>
            </div>
          </div>
        </Portal>
      )}
    </div>
  )
}

export default TimeSelector
